module.exports = __webpack_public_path__ + "static/TruenoLt-a303c84bc05cf2c07475ce38efdebb4a.woff2";